import Communication from "./Communication";
import Email from "./Email";
import FullName from "./FullName";
import Password from "./Password";

export default function ProfileSettings() {
  return (
    <div>
      <FullName />
      <Email />
      <Password />
      <Communication />
    </div>
  );
}
